import Badge from './Badge';

export default {
  id: 'radial_3',
  title: 'Radial_3',
  colors: 3,
  animated: true,
  premium: true,
  BadgeComponentStateless: Badge
};
